module.exports = __webpack_public_path__ + "MaterialIcons-Regular.e79bfd88537def476913.eot";


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@covalent/core/common/styles/font/MaterialIcons-Regular.eot
// module id = ../../../../@covalent/core/common/styles/font/MaterialIcons-Regular.eot
// module chunks = 2